// extracted by mini-css-extract-plugin
export default {"page":"ChannelPartner_page__rcKLG"};